import * as usageStickTypes from '../../containers/DeviceSettingsPage/components/UsageStatsPage/components/UsageStatsContent/consts/usageStickTypes';
import usageStatsConverter from '../../services/uam/usageStatsConverter';

export const CLEAR_HOLDER_ASSET_USAGE = 'app/usageStatistic/CLEAR_HOLDER_ASSET_USAGE';
export const CLEAR_USAGE_STATS = 'app/usageStatistic/CLEAR_USAGE_STATS';
export const CLEAR_USAGE_STATS_DETAILS = 'app/usageStatistic/CLEAR_USAGE_STATS_DETAILS';
export const SET_USAGE_STATS = 'app/usageStatistic/SET_USAGE_STATS';
export const SET_ASSET_ID_LIST = 'app/usageStatistic/SET_ASSET_ID_LIST';
export const SET_EXPERIENCE_DATA_RANGES = 'app/usageStatistic/SET_EXPERIENCE_DATA_RANGES';
export const SET_USAGE_IS_12_HOURS_MODE = 'app/usageStatistic/SET_USAGE_IS_12_HOURS_MODE';
export const SET_USAGE_ACTIVE_TAB = 'app/usageStatistic/SET_USAGE_ACTIVE_TAB';

const initialState = {
    usageStats: [],
    usageStatsDetails: [],
    assetIdList: [],
    experienceDataRanges: undefined,
    usageActiveTab: usageStickTypes.TEREA,
    usageIs12HoursMode: false,
};

export default function reducer(state = initialState, action) {
    const {payload, type} = action;

    switch (type) {
        case CLEAR_USAGE_STATS: {
            return {...state, usageStatsDetails: [], usageStats: [], assetIdList: []};
        }
        case CLEAR_USAGE_STATS_DETAILS: {
            return {...state, usageStatsDetails: []};
        }
        case SET_USAGE_STATS: {
            const updatedUsageData = getUpdatedUsageStats(state.usageStatsDetails, payload);
            const sumUsageData = usageStatsConverter.sumUsageData(updatedUsageData);

            return {...state, usageStatsDetails: updatedUsageData, usageStats: sumUsageData};
        }
        case CLEAR_HOLDER_ASSET_USAGE: {
            const assetId = payload;

            const updatedUsageList = state.usageStatsDetails.filter((usageItem) => usageItem?.assetId !== assetId);
            const sumUsageData = usageStatsConverter.sumUsageData(updatedUsageList);

            return {...state, usageStatsDetails: updatedUsageList, usageStats: sumUsageData};
        }
        case SET_ASSET_ID_LIST: {
            const {codentify, assetId, uamApiKey, uamAuthToken, authToken} = payload;
            const {assetIdList} = state;
            const assetIdListNew = [...assetIdList];

            if (assetId) {
                if (assetIdListNew.some((el) => el.assetId === assetId)) return state;

                assetIdListNew.push({codentify, assetId, uamApiKey, uamAuthToken});
                return {...state, assetIdList: [...assetIdListNew]};
            } else {
                const updatedAssetIdList = assetIdListNew.map((item) => {
                    if (item.codentify && codentify) {
                        if (item.codentify === codentify) {
                            item.uamApiKey = uamApiKey;
                            item.uamAuthToken = authToken;
                        }
                    }
                    return item;
                });

                return {...state, assetIdList: [...updatedAssetIdList]};
            }
        }
        case SET_EXPERIENCE_DATA_RANGES: {
            return {...state, experienceDataRanges: payload};
        }
        case SET_USAGE_ACTIVE_TAB: {
            return {...state, usageActiveTab: payload};
        }
        case SET_USAGE_IS_12_HOURS_MODE: {
            return {...state, usageIs12HoursMode: payload};
        }

        default: {
            return state;
        }
    }
}

export const clearHolderAssetUsage = (assetId) => ({
    type: CLEAR_HOLDER_ASSET_USAGE,
    payload: assetId,
});

export const clearUsageStats = () => ({
    type: CLEAR_USAGE_STATS,
});

export const clearUsageStatsDetails = () => ({
    type: CLEAR_USAGE_STATS_DETAILS,
});

export const setUsageStats = (data) => ({
    type: SET_USAGE_STATS,
    payload: data,
});

export const setAssetIdList = (data) => ({
    type: SET_ASSET_ID_LIST,
    payload: data,
});

export const setExperienceDataRanges = (data) => ({
    type: SET_EXPERIENCE_DATA_RANGES,
    payload: data,
});

export const setUsageIs12HoursMode = (data) => ({
    type: SET_USAGE_IS_12_HOURS_MODE,
    payload: data,
});

export const setUsageActiveTab = (data) => ({
    type: SET_USAGE_ACTIVE_TAB,
    payload: data,
});

const getUpdatedUsageStats = (usageList, payload) => {
    let updatedUsageStats;

    if (payload.length) {
        updatedUsageStats = getUpdateUsageStatsList(usageList, payload);
    } else {
        updatedUsageStats = getUpdateUsageStatsItem(usageList, payload);
    }

    return updatedUsageStats;
};

const getUpdateUsageStatsItem = (usageList, payload) => {
    const updatedUsageList = usageList.filter((usageItem) => usageItem?.assetId !== payload?.assetId);

    updatedUsageList.push(payload);

    return updatedUsageList;
};

const getUpdateUsageStatsList = (usageList, payload) => {
    if (!usageList?.length) {
        return payload;
    }

    payload.forEach((usageData) => {
        usageList = getUpdateUsageStatsItem(usageList, usageData);
    });

    return usageList;
};
